import { ModuleLayout, Space } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { RecurringInvoicesListFiltersProvider } from './context/recurringInvoicesListFilters'
import { RecurringInvoicesSideActions } from './elements/RecurringInvoicesSideActions'
import { RecurringInvoicesSummary } from './elements/RecurringInvoicesSummary'
import { RecurringInvoicesTable } from './elements/RecurringInvoicesTable'
import { RecurringInvoicesTableActions } from './elements/RecurringInvoicesTableActions'

export const RecurringInvoicesList = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <ModuleLayout sideActions={<RecurringInvoicesSideActions />} title={t('recurring_invoices')}>
      <RecurringInvoicesListFiltersProvider>
        <RecurringInvoicesSummary />
        <Space />
        <RecurringInvoicesTableActions />
        <RecurringInvoicesTable />
      </RecurringInvoicesListFiltersProvider>
    </ModuleLayout>
  )
}
